module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 06 Farma Pasa - Karpe diem (gost. Direkt).d9b32619.mp3";